import React, { Fragment, PureComponent } from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import { colors } from '../../../constants'

const White = styled.span`
    color: ${colors.white};
`

const Grey = styled.span`
    color: ${colors.grey};
`

class FooterLabel extends PureComponent {
    static propTypes = {
        loading: PropTypes.bool,
        noResults: PropTypes.bool,
        t: PropTypes.func.isRequired,
    }

    static defaultProps = {
        loading: false,
        noResults: false,
    }

    renderLabel() {
        const { loading, noResults, t } = this.props

        if (loading) {
            return <White>{`${t('Loading')}...`}</White>
        }

        if (noResults) {
            return <Grey>{t('No Results Found')}</Grey>
        }

        return null
    }

    render() {
        return <Fragment>{this.renderLabel()}</Fragment>
    }
}

export default withTranslation()(FooterLabel)
